'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import { cn } from '@/frontend/utils';
import { Button } from '../Button';
export function DropdownButton(t0) {
  const $ = _c(10);
  let T0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    const {
      as: t4,
      ...props
    } = t0;
    const as = t4 === undefined ? Button : t4;
    T0 = Headless.MenuButton;
    t1 = as;
    t2 = props;
    t3 = cn("data-active:ring-2 data-active:ring-algonavy-400 data-active:ring-outline", props.className);
    $[0] = t0;
    $[1] = T0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    T0 = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== T0 || $[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <T0 as={t1} {...t2} className={t3} />;
    $[5] = T0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}